import { type SimilarProduct } from '@/modules/similar/aliases';

export function getYMALProductPrice(
  pricing: SimilarProduct['pricing']
): number {
  const finalPrice = pricing?.final_price_key;
  const priceEstimate = pricing?.[finalPrice];

  if (!priceEstimate) {
    return parseFloat(pricing.original_price.total_price);
  }

  return parseFloat(priceEstimate.total_price);
}
